import { COMPONENT_VALUE_TYPES as types, APP_HANDLERS, COMPONENT_COLOR_THEMES } from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

export type ColorTheme = 'LIGHT' | 'DARK';

export interface Props {
  button: {
    label: string;
    url: string;
    appHandlerKey?: string;
  };
  colorTheme: ColorTheme;
  hidden_controls?: {
    hide_on_desktop?: boolean;
    hide_on_tablet?: boolean;
    hide_on_mobile?: boolean;
    hide_in_app?: boolean;
  };
  editor?: object;
}

const propsSchema: PropsSchemaList = [
  {
    key: 'button',
    label: 'Button',
    type: types.OBJECT,
    children: [
      {
        key: 'label',
        label: 'Button Label',
        type: types.TEXT,
      },
      {
        key: 'url',
        label: 'Button URL',
        type: types.TEXT,
      },
      {
        key: 'appHandlerKey',
        label: 'Use App Handler',
        tooltip: 'Use App Handler to open a page in the FF Mobile APP',
        type: types.ENUM,
        options: APP_HANDLERS,
      },
    ],
  },
  {
    key: 'colorTheme',
    label: 'Color Theme',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES,
  },
  {
    key: 'hidden_controls',
    label: 'Visibility Controls',
    type: types.OBJECT,
    children: [
      {
        key: 'hide_on_desktop',
        label: 'Hide On Desktop',
        type: types.BOOLEAN,
      },
      {
        key: 'hide_on_tablet',
        label: 'Hide On Tablet',
        type: types.BOOLEAN,
      },
      {
        key: 'hide_on_mobile',
        label: 'Hide On Mobile',
        type: types.BOOLEAN,
      },
      {
        key: 'hide_in_app',
        label: 'Hide In App',
        type: types.BOOLEAN,
      },
    ],
  },
];

const defaultProps: Props = {
  button: {
    label: 'Pre-Order Now',
    url: 'https://www.ff.com/us/preorder/fx',
    appHandlerKey: '',
  },
  colorTheme: 'DARK',
  hidden_controls: {
    hide_on_desktop: false,
    hide_on_tablet: false,
    hide_on_mobile: false,
    hide_in_app: false,
  },
};

export default {
  title: 'Floating CTA',
  id: 'FloatingCTA',
  propsSchema,
  defaultProps,
}
